export const BOOK_CATEGORIES = [
  'Technology',
  'Engineering',
  'Software Development',
  'Leadership',
  'Business',
  'Personal Development',
  'Architecture',
  'Security',
  'Life'
];

export const ARCHIVE_BOOK_CATEGORIES = [
  'All Archived',
  'Completed',
  'Reference',
  'Classics'
];

export interface Book {
  id: string;
  title: string;
  author: string;
  startedAt?: string;
  completedAt?: string;
  category: string;
  link?: string;
  status: 'Currently Reading' | 'Want to Read' | 'Completed' | 'On Hold';
  excerpt?: string;
  tags: string[];
  readingTime?: string;
  rating?: number;
  archived?: boolean;
  archiveCategory?: string;
}

export const books: Book[] = [
  {
    id: 'dont-believe-everything-you-think',
    title: 'Don\'t Believe Everything You Think',
    author: 'Joseph Nguyen',
    startedAt: 'January 2025',
    category: 'Life',
    link: 'https://amzn.in/d/f7lseaF',
    status: 'Currently Reading',
    excerpt: 'A guide to understanding your thoughts and breaking free from limiting beliefs. Learn to observe your thoughts without being controlled by them.',
    tags: ['Mindfulness', 'Self-Help', 'Personal Growth', 'Psychology'],
    readingTime: 'Medium read'
  },
  {
    id: 'software-engineers-guidebook',
    title: 'The Software Engineer\'s Guidebook: Navigating Senior, Tech Lead, and Staff Engineer Positions at Tech Companies and Startups (Greyscale Indian Edition)',
    author: 'Gergely Orosz',
    category: 'Engineering',
    link: 'https://amzn.in/d/6pb1mUO',
    status: 'Want to Read',
    excerpt: 'A comprehensive guide to advancing your engineering career. Navigate the transition to Senior, Tech Lead, and Staff Engineer roles at tech companies and startups.',
    tags: ['Career Development', 'Engineering', 'Leadership', 'Tech Career'],
    readingTime: 'Medium read'
  },
  {
    id: 'art-of-systems-architecting',
    title: 'The Art of Systems Architecting (Systems Engineering)',
    author: 'Mark W. Maier, Eberhardt Rechtin',
    category: 'Architecture',
    link: 'https://amzn.in/d/63vhDlR',
    status: 'Want to Read',
    excerpt: 'A comprehensive guide to systems architecting principles and practices. Learn how to design and architect complex systems effectively.',
    tags: ['Systems Engineering', 'Architecture', 'Design', 'Engineering'],
    readingTime: 'Long read'
  },
  {
    id: 'database-internals',
    title: 'Database Internals: A Deep Dive into How Distributed Data Systems Work (Greyscale Indian Edition)',
    author: 'Alex Petrov',
    category: 'Technology',
    link: 'https://amzn.in/d/1cki50F',
    status: 'Want to Read',
    excerpt: 'A deep dive into the internals of distributed data systems. Learn how databases work at a fundamental level, from storage engines to distributed consensus.',
    tags: ['Database', 'Distributed Systems', 'Systems Engineering', 'Data Storage'],
    readingTime: 'Long read'
  },
  {
    id: 'clean-code',
    title: 'Clean Code: A Handbook of Agile Software Craftsmanship',
    author: 'Robert C. Martin',
    category: 'Software Development',
    link: 'https://amzn.in/d/2Z35No9',
    status: 'Want to Read',
    excerpt: 'A guide to writing clean, readable, and maintainable code. Essential principles for professional software development and agile craftsmanship.',
    tags: ['Programming', 'Best Practices', 'Code Quality', 'Agile', 'Software Craftsmanship'],
    readingTime: 'Medium read'
  },
  {
    id: 'head-first-design-patterns',
    title: 'Head First Design Patterns: Building Extensible and Maintainable Object-Oriented Software',
    author: 'Eric Freeman, Elisabeth Robson, Bert Bates, Kathy Sierra',
    completedAt: 'January 2025',
    category: 'Software Development',
    link: 'https://amzn.in/d/1ViiGqh',
    status: 'Completed',
    excerpt: 'A brain-friendly guide to design patterns. Learn how to write better object-oriented code using proven design patterns.',
    tags: ['Design Patterns', 'Object-Oriented Programming', 'Software Design', 'Best Practices'],
    readingTime: 'Long read',
    rating: 5,
    archived: true,
    archiveCategory: 'Completed'
  },
  {
    id: 'head-first-object-oriented-analysis-design',
    title: 'Head First Object-Oriented Analysis & Design: A Brain Friendly Guide to OOA&D',
    author: 'Brett McLaughlin, Gary Pollice, David West',
    completedAt: 'January 2025',
    category: 'Software Development',
    link: 'https://amzn.in/d/il2Z5s8',
    status: 'Completed',
    excerpt: 'A brain-friendly guide to object-oriented analysis and design. Learn how to analyze, design, and write better object-oriented software.',
    tags: ['Object-Oriented Programming', 'Software Design', 'Analysis', 'Design', 'OOA&D'],
    readingTime: 'Long read',
    rating: 5,
    archived: true,
    archiveCategory: 'Completed'
  }
];
